import axios from 'axios'
import { BASE_URL, dataGetter } from 'utils/api'

const RESOURCE_LOCATION = `${BASE_URL}/api/farm_owners/:farmOwnerId/land/farms/:farmId/optimizer_runs`
export const create = (optimizer_run) =>
  axios.post(RESOURCE_LOCATION, { optimizer_run }).then(dataGetter)

export const get = (id) =>
  axios.get(`${RESOURCE_LOCATION}/${id}`).then(dataGetter)
